import getters from '@/store/modules/chat/getters';
import mutations from '@/store/modules/chat/mutations';
import actions from '@/store/modules/chat/actions';
import { createChatModuleState } from '@/store/modules/chat/state';

const state = createChatModuleState();

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
